<template>
    <van-overlay :show="show" :lock-scroll="true">
        <div class="wrapper">
            <div class="content">
                <van-icon
                    @click="onClickHide"
                    class="icon-close"
                    name="cross"
                    color="#254D5E"
                    size="1.2em"
                />
                <div class="content-title f-18-bold text-layout-center">领取成功</div>
                <div class="content-value">
                    <div
                        v-if="content.code"
                        class="content-value-detail flex-layout-h flex-justify-space f-12"
                    >
                        <div>兑换码：</div>
                        <div class="content-value-detail-number">
                            <div class="number-value">{{ content.code }}</div>
                        </div>
                        <div
                            class="content-value-detail-copy text-layout-center f-10"
                            @click="onCopyClick(content.code)"
                        >
                            复制
                        </div>
                    </div>
                    <div
                        v-if="content.account"
                        class="content-value-detail flex-layout-h flex-justify-space f-12"
                    >
                        <div>卡号：</div>
                        <div class="content-value-detail-number">
                            <div class="number-value">{{ content.account }}</div>
                        </div>
                        <div
                            class="content-value-detail-copy text-layout-center f-10"
                            @click="onCopyClick(content.account)"
                        >
                            复制
                        </div>
                    </div>
                    <div
                        v-if="content.password"
                        class="content-value-detail flex-layout-h flex-justify-space f-12"
                    >
                        <div>卡密：</div>
                        <div class="content-value-detail-number">
                            <div class="number-value">{{ content.password }}</div>
                        </div>
                        <div
                            class="content-value-detail-copy text-layout-center f-10"
                            @click="onCopyClick(content.password)"
                        >
                            复制
                        </div>
                    </div>
                </div>
                <div class="content-line w-full"></div>
                <div
                    class="content-btn f-16-bold text-layout-center"
                    v-if="content.link"
                    @click="onBtnClick"
                >
                    去兑换
                </div>
                <div class="content-btnwithoutUrl f-12 text-layout-center" v-else>
                    具体兑换方式请查看权益领取说明
                </div>
            </div>
        </div>
    </van-overlay>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        content: {
            type: Object,
            default: {
                // link: '',
                // account: '35467287897689776',
                // password: '',
                // code: ''
            }
        }
    },
    methods: {
        onClickHide() {
            this.$emit('onClickHide');
        },
        onBtnClick() {
            this.onClickHide();
            this.$copyText(this.content.code || this.content.account).then(
                () => {
                    this.$toast({ message: '复制成功', duration: 2000 });
                },
                () => {
                    this.$toast({ message: '复制失败', duration: 2000 });
                }
            );
            setTimeout(() => {
                location.href = this.content.link;
            }, 1000);
        },
        onCopyClick(url) {
            this.$copyText(url).then(
                () => {
                    this.$toast({ message: '复制成功', duration: 2000 });
                },
                () => {
                    this.$toast({ message: '复制失败', duration: 2000 });
                }
            );
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    > .content {
        position: relative;
        width: 271px;
        border-radius: 4px;
        background-color: white;
        .icon-close {
            position: absolute;
            top: 13px;
            right: 13px;
        }
        .content-title {
            margin-top: 32px;
        }
        .content-line {
            background: #dae0ec;
            height: 1px;
            margin-top: 20px;
            transform: scaleY(0.5);
        }
        .content-value {
            background: rgba(247, 247, 247, 1);
            width: 242px;
            margin: 12px;
            margin-top: 14px;
            padding: 20px 12px;
            &-detail {
                color: #254d5e;
                margin-top: 17px;
                align-items: flex-start;
                &-copy {
                    width: 32px;
                    height: 14px;
                    color: #254d5e;
                    line-height: 14px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 7px;
                }
                &-number {
                    flex: 1;
                    align-self: flex-start;
                    > .number-value {
                        width: 135px;
                        overflow-wrap: break-word;
                        overflow: hidden;
                        line-height: 16px;
                    }
                }
                &:first-child {
                    margin-top: 0px;
                }
            }
        }
        .content-valuef:first-child:nth-last-child(1) {
            padding: 30px 12px;
        }
        .content-btn {
            height: 50px;
            color: #3a90c2;
            line-height: 50px;
        }
        .content-btnwithoutUrl {
            height: 50px;
            color: #9faab5;
            line-height: 50px;
        }
    }
}
</style>
